import { useEffect, useState } from "react";
import { config } from "../configs/config";

// Custom hook to track the viewport width
export const usePwaViewportWidth = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth); // Update the viewport width
    };

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const pwaViewportWidth = viewportWidth < config.pwaWidth ? viewportWidth : config.pwaWidth;

  return pwaViewportWidth;
};
